const multipleUnits = {
  feilds: [
    {
      id: 0,
      name: "unit_dashboard",
      text: "Unit",
      visible: true,
      element: "select2",
      required: true,
      input_type: "text",
      placeholder: "Select Unit",
      icon: "",
      rules: [],
      errors: [],
      value: null,
      valid: false,
      state: "",
      disable: false,
      className: "",
    },
    {
      id: 1,
      name: "date",
      text: "Date",
      visible: true,
      element: "daterange",
      required: true,
      input_type: "date",
      placeholder: "Date",
      icon: "",
      rules: [],
      errors: [],
      value: null,
      valid: false,
      state: "",
      disable: false,
      showSearch: false,
      className: "col-4 d-flex pr-0 float-right",
    },
    {
      id: 2,
      name: "dashboardFilters",
      text: "Filters",
      visible: true,
      element: "select2",
      required: true,
      input_type: "text",
      placeholder: "Select Filter",
      icon: "",
      rules: [],
      errors: [],
      value: null,
      valid: false,
      state: "",
      disable: false,
      className: "",
    },
    {
      id: 3,
      name: "reporttype",
      text: "Report Type",
      // visible: true,
      // element: "select2",
      // required: true,
      input_type: "text",
      value: null,
      valid: false,
    },
  ],
};

export { multipleUnits };
